import React, {Component} from 'react';
import {
    Platform,
    View,
    TouchableOpacity,
    Image,
    I18nManager,
    Clipboard
} from 'react-native';
import HMTextView from "./HMTextView";
import Colors from "../tools/Colors"
import {moderateScale} from "../tools/Scaling";
import {connect} from "react-redux";

import * as NavigationService from "../redux/NavigationService";
import store from "../redux/store";
import {AsyngStorageClass} from "../tools/AsyngStorageClass";
import HMIcon from "./HMIcon";
import PathFile from "../assets/PathFile";


class HMActionBarSatia extends Component {
    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };

    hideMenu = () => {
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    render() {
        const {CentralView,styleRoot,styleRootParent,LeftView, onClickProfile, exit, profile, menu, text, logo, more_menu, back, onBackPress, headerVisibility, statusBarTransparent, style, transparent, drawer, props} = this.props;
        let checkLogin = false

        let {Rtl} = this.props
        return (
            <View style={styleRootParent} >{
                headerVisibility ?
                    <View>
                        {/*                <StatusBar translucent={statusBarTransparent} barStyle="light-content"
                           backgroundColor={statusBarTransparent ? "rgba(256,256,256,0)" : Colors.backgroundColorDarker}/>*/}
                        {Platform.OS === 'ios' ?
                            <View style={{
                                backgroundColor: Platform.OS === 'ios' ? Colors.colorPrimaryDark : Colors.transparent,
                                width: '100%',
                                //height:Constants.HeightStatusBar,
                                height: moderateScale(20)

                            }}/> : null}

                        <View
                            style={[{
                                // flexDirection: Rtl ? 'row-reverse' : 'row',
                                flexDirection: 'row',

                                //   justifyContent: Rtl ? 'flex-start' : 'flex-end',
                                height: Platform.OS === "ios" ? moderateScale(48) : moderateScale(48),
                                alignItems: 'center',
                                backgroundColor: Colors.colorPrimary,
                            },styleRoot?styleRoot:{}]}>


                            <View style={[{
                                // flexDirection: Rtl ? 'row-reverse' : 'row',
                                flexDirection: 'row',
                                //alignSelf:Rtl   ?  "flex-start" : "flex-end",
                                // width:  Constants.WIDTH/2-moderateScale(26),
                                // height: moderateScale(48)
                                //backgroundColor: '#ee050d'

                                //marginHorizontal: moderateScale(6),
                                justifyContent: 'center',
                                alignItems: 'center',
                            }, (profile || back) && (!menu || checkLogin) ? {
                                width: moderateScale(48),
                                height: moderateScale(48),
                            } : {}]}>
                                {menu && !checkLogin ? <TouchableOpacity
                                        style={{

                                            //    marginHorizontal: moderateScale(10),
                                            width: moderateScale(48),
                                            height: moderateScale(48),

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}

                                        onPress={

                                            //  onBackPress
                                            () => {

                                                //alert(this.props.token_fb)
                                                if (Platform.OS === "web")
                                                // this.props.navigation.toggleDrawer()
                                                    if (Clipboard)
                                                        Clipboard.setString(this.props.token_fb)
                                                props.navigation.toggleDrawer()
                                            }
                                        }>
                                        <HMIcon name={"ios-menu"}
                                                style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </TouchableOpacity>
                                    :
                                    null
                                }

                            </View>

                            {CentralView ?
                                CentralView()
                                :
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        flex: 1,
                                        justifyContent: 'center',
                                        alignItems: 'center',

                                    }}>
                                    {
                                        logo ?
                                            <Image

                                                //resizeMode={"stretch"}
                                                style={{
                                                    width: moderateScale(50),
                                                    height: moderateScale(27),

                                                    //position: 'absolute',
                                                    //borderRadius: 50),
                                                    //     backgroundColor: Colors.white


                                                }}
                                                // source={require('../../../assets/img/logo.png')}
                                                source={PathFile.image.name_satia}
                                                //source={{uri: "https://painrelief-blog.org/wp-content/uploads/2019/07/5d2233166143e.jpg"}}
                                            />
                                            :
                                            <HMTextView numberOfLines={1} text={text} type="bold" style={{
                                                alignSelf: "center",
                                                color: Colors.light,
                                                fontSize: moderateScale(16),


                                            }}/>
                                    }

                                </View>
                            }


                            <View
                                style={[{

                                flexDirection: 'row',
                                //    marginHorizontal: moderateScale(10),
                                // width:Constants.WIDTH/2-moderateScale(26),
                                // width:0,
                                // height: moderateScale(48),

                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingEnd: moderateScale(LeftView ? 2 : 0),

                            }, !(back && profile) && (menu) ? {
                                width: moderateScale(LeftView?58:48),
                                height: moderateScale(48),
                            } : {}]}>
                                {LeftView}

                                {back ? <TouchableOpacity
                                    style={{
                                        //  backgroundColor: "#ee1c27",

                                        //    marginHorizontal: moderateScale(10),
                                        width: moderateScale(LeftView ? 24 : 48),
                                        height: moderateScale(48),

                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}

                                    onPress={
                                        () => {
                                            drawer ? props.navigation.popToTop() :
                                                //props.navigation.pop()
                                                (
                                                    Platform.OS === "web" ?
                                                        window.history.back()
                                                        //  this.props.history.goBack()
                                                        :
                                                        props.navigation.pop()
                                                )


                                        }

                                    }>
                                    <View style={{
                                        //  flexDirection:Rtl ? 'row-reverse': 'row',
                                        flexDirection: 'row',
                                        alignItems: "flex-end",
                                        //marginHorizontal: moderateScale(4)
                                    }}>
                                        <HMIcon name={
                                            //Rtl ? "ios-arrow-back":'ios-arrow-forward'
                                            I18nManager.getConstants().isRTL ? "ios-arrow-back" : 'ios-arrow-forward'
                                            // 'ios-arrow-back'

                                        }
                                                style={{fontSize: moderateScale(24), color: Colors.light}}/>
                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </View>
                                </TouchableOpacity> : null}

                                {exit ? <TouchableOpacity
                                    style={{

                                        //    marginHorizontal: moderateScale(10),
                                        width: moderateScale(LeftView ? 24 : 48),
                                        height: moderateScale(48),

                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}

                                    onPress={
                                        () => {
                                            AsyngStorageClass.removeToken();

                                            // NavigationService.resetTo("SplashSatiaScreen")
                                        }
                                        //  onBackPress
                                        // () => {
                                        //     Tools.changeAppLang('en');
                                        // }
                                    }>
                                    <View style={{
                                        //  flexDirection:Rtl ? 'row-reverse': 'row',
                                        flexDirection: 'row',
                                        alignItems: "flex-end",
                                        //marginHorizontal: moderateScale(4)
                                    }}>
                                        <HMIcon name={"md-log-in"}
                                                style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </View>
                                </TouchableOpacity> : null}

                                {profile && !checkLogin ? <TouchableOpacity
                                    style={{

                                        //    marginHorizontal: moderateScale(10),
                                        width: moderateScale(LeftView ? 24 : 48),
                                        height: moderateScale(48),

                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}

                                    onPress={
                                        () => {
                                            //   NavigationService.navigateParams('ProfileScreen')
                                            if (store.getState().reducerSplashSatiaScreen.token != null) {


                                                NavigationService.navigateParams('ProfileSatiaScreen')


                                            } else {

                                                //  store.dispatch(serviceActionSetState({type: "ProfileSatiaScreen"}));
                                                NavigationService.navigateParams('LoginEnterPhoneSatiaScreen')


                                            }
                                            // props.navigation.pop()
                                        }
                                        //  onBackPress
                                        // () => {
                                        //     Tools.changeAppLang('en');
                                        // }
                                    }>
                                    <View style={{
                                        //  flexDirection:Rtl ? 'row-reverse': 'row',
                                        flexDirection: 'row',
                                        alignItems: "flex-end",
                                        //marginHorizontal: moderateScale(4)
                                    }}>
                                        <HMIcon name={"md-person"}
                                                style={{fontSize: moderateScale(25), color: Colors.light}}/>

                                    </View>
                                </TouchableOpacity> : null}


                            </View>
                        </View>
                    </View>
                    :
                    null
            }

            </View>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        token_fb: state.reducerSplashSatiaScreen.token_fb,
        // CartList: state.reducerSplashGetAllData.CartList,
        // PriceAll: state.reducerSplashGetAllData.PriceAll,
        // Rtl: state.reducerSplashGetAllData.Rtl,
        // data_splash: state.reducerSplashGetAllData
    }
}
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceAddCart: (data) => dispatch(serviceActionAddCart(data)),
        //  callServiceSubCart: (data) => dispatch(serviceActionSubCart(data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HMActionBarSatia);
